import { dataGroupMapRef } from './consts';

export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  div.data-group-map {
    min-height: 20px
  }
  </style>
  `;

  if (c.blocks.indexOf(dataGroupMapRef) >= 0) {
    bm.add(dataGroupMapRef, {
      label: `<i class="webconnect-google-maps"></i><div>${c.labelGroupMap}</div>`,
      category: c.labelGroupMapCategory,
      content: `<div class="${dataGroupMapRef}" role="${dataGroupMapRef}" data-gjs-type="${dataGroupMapRef}" data-gjs="${dataGroupMapRef}">
          ${style}
      </div>`,
    });
  }
}
